/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './styles.module.scss';

const SubTitleShared = ({ className = null, children = null }) => (
  <div className={cx(s.subTitle, className)}>{children}</div>
);

SubTitleShared.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SubTitleShared;
